export function parseDate(date: string | null) {
    if (date) {
        const [year, month, day] = date.split('-')
        return day ? day + '/' + month + '/' + year : null
    }
    return null
}
export function parseDateTime(datetime: string | null) {
    if (datetime) {
        const [date, time] = datetime.split(' ')
        const [year, month, day] = date.split('-')
        return day ? day + '/' + month + '/' + year + ' ' + time : null
    }
    return null
}

export function getWeekdayName(date: string) {
    const weekdayNames = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"]
    const [year, month, day] = date.split('-')

    return weekdayNames[new Date(Number(year), Number(month) - 1, Number(day)).getDay()]
}